import React from 'react';
import Lottie from 'react-lottie';
import './Return_Lottie.css';
import * as animationData from './Return_Lottie.json';

function Return_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Return_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}
                // height={60}
                // width={60}          
                />       
        </div>
      </section>
    );
}
export default Return_Lottie;